<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { computed } from "vue"
import { ThemeButton } from "~/components/theme"
import { Separator } from "~/components/ui/separator"
import { useLocation } from "~/composables/locations"
import { cn } from "~/lib/utils"

const { class: cl } = defineProps<{
    class?: HTMLAttributes["class"]
}>()

const { location } = useLocation()

const giftCardsRewards = computed(() => location.value?.pageContent?.giftCardsRewards)
const giftCards = computed(() => giftCardsRewards.value?.giftCards)
const rewards = computed(() => giftCardsRewards.value?.rewards)

const giftCardUrl = computed(() => giftCards.value?.url || location.value?.external?.url?.giftCard || "")
const rewardsUrl = computed(() => rewards.value?.url || location.value?.external?.url?.loyaltyRewards || "")
</script>

<template>
    <section
        id="gift-cards-rewards"
        tabindex="-1"
        :class="cn('space-y-10 md:space-y-12', cl)"
    >
        <header class="space-y-6 text-center">
            <h2 class="text-3xl md:text-4xl font-headline">
                Gift Cards & Rewards
            </h2>
        </header>
        <div class="grid md:grid-cols-2 gap-6">
            <div class="bg-foreground-faded text-foreground border-l-8 border-background/50 p-6 flex flex-col items-center gap-6">
                <header class="space-y-6 text-center">
                    <h3 class="text-xl font-headline">
                        {{ giftCards?.title }}
                    </h3>
                    <Separator class="w-10 mx-auto bg-foreground/50" />
                    <div
                        class="text-center text-balance space-y-2"
                        v-html="giftCards?.content || ''"
                    />
                </header>
                <ThemeButton
                    size="lg"
                    as-child
                >
                    <a
                        :href="giftCardUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        tabindex="0"
                    >
                        Purchase
                    </a>
                </ThemeButton>
            </div>
            <div class="bg-foreground-faded text-foreground border-l-8 border-background/50 p-6 flex flex-col items-center gap-6">
                <header class="space-y-6 text-center">
                    <h3 class="text-xl font-headline">
                        {{ rewards?.title }}
                    </h3>
                    <Separator class="w-10 mx-auto bg-foreground/50" />
                    <div
                        class="text-center text-balance space-y-2"
                        v-html="rewards?.content || ''"
                    />
                </header>
                <ThemeButton
                    size="lg"
                    as-child
                >
                    <a
                        :href="rewardsUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        tabindex="0"
                    >
                        Join Now
                    </a>
                </ThemeButton>
            </div>
        </div>
    </section>
</template>
